export default __webpack_public_path__ + "static/media/Failed_icon.0a4d5c48.svg";